'use client';

import { useEffect } from 'react';

/** A bfcache restore revives the old checkout with frozen busy state; reload so the server picks the step. */
export function useReloadOnPageRestore() {
  useEffect(() => {
    const handlePageShow = (event: PageTransitionEvent) => {
      if (event.persisted) {
        window.location.reload();
      }
    };

    window.addEventListener('pageshow', handlePageShow);

    return () => window.removeEventListener('pageshow', handlePageShow);
  }, []);
}
